import _ from 'lodash'
import {
  validateDiscountCode,
  toggleDiscountCode as toggleDiscountCodeAction,
  types as discountCodeTypes
} from './'
import notifications, {
  toastError,
  toastServerError,
  toastSuccess
} from '../../../global/notifications'

export default (dispatch, ownProps) => ({
  onSubmit(data) {
    let plan
    if (_.isNumber(ownProps.plan)) plan = ownProps.plan
    else if (
      ownProps.plan &&
      Object.prototype.hasOwnProperty.call(ownProps.plan, 'id')
    )
      plan = ownProps.plan.id
    else plan = null
    dispatch(validateDiscountCode(data.code.toUpperCase(), plan)())
      .then(([_, res]) => {
        if (res.type === discountCodeTypes.VALIDATE_DISCOUNT_CODE_SUCCESS)
          toastSuccess(notifications.discountCodeValid)
        else toastError(notifications.discountCodeValid)
      })
      .catch((payload) => {
        const error = payload.errors
        toastServerError(error)
        toastError(notifications.discountCodeValid)
      })
  },
  toggleDiscountCode() {
    dispatch(toggleDiscountCodeAction())
  }
})
